import { getTableIBM } from "../../data.checker";
import { IBM_TABLES } from "./tables";

export interface Proforma {
  _id?: string;
  businessType: 'N' | 'S';
  code?: string;
  buyerId: number;
  priceDiscount: number;
  agreedDiscount: number;
  paymentCode: number;
  paymentDays: number;
  inheritPaymentTerms: boolean;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
}

function normalizeProformas(data: unknown): Proforma[] {
  return Array.isArray(data) ? data as Proforma[] : [];
}

export let proformas: Proforma[] = normalizeProformas(
  getTableIBM(IBM_TABLES.CER050TC, true),
);

export let proformasByBuyerAndType: { [key: string]: Proforma } = {};

function buildProformasIndex(data: unknown): { [key: string]: Proforma } {
  const index: { [key: string]: Proforma } = {};
  for (const p of normalizeProformas(data)) {
    const key = `${p.buyerId}_${p.businessType.toUpperCase()}`;
    index[key] = p;
  }
  return index;
}

proformasByBuyerAndType = buildProformasIndex(proformas);

export function updateProformas(data: unknown) {
  proformas = normalizeProformas(data);
  proformasByBuyerAndType = buildProformasIndex(proformas);
}

export function getProforma(buyerId: number, businessType: string): Proforma | undefined {
  const key = `${buyerId}_${businessType.toUpperCase()}`;
  return proformasByBuyerAndType[key];
}
